import { Button, Col, Input, Row, Space } from 'antd';
import React from 'react';
import "./formulaires.css";
import Title from 'antd/es/typography/Title';
import { LinkedinOutlined, MailOutlined, MessageOutlined, TwitterOutlined } from '@ant-design/icons';

const PartageFormulaire = () => {
    return (
        <div  className="divGB" >
            <Title level={4} >Lien public</Title>
            <Space.Compact style={{ width: '50%', }}>
                <Input variant='filled' defaultValue="https://app.test/form/12345" style={{fontSize:"18px"}} />
                <Button  style={{padding:"5%", backgroundColor:"#43CE0C", color:"#fff", fontSize:"18px"}}>Copier</Button>
            </Space.Compact>
            <Row>
                <Col span={12} className="colIcons">
                    <div className="divMessage"><MessageOutlined className='iconMessage'/>Message</div>
                    <div className="divMessage"><MailOutlined className='iconMeil' />Mail</div>
                    <div className="divMessage"><LinkedinOutlined className='iconMessage' />LinkedIn</div>
                    <div className="divMessage"><TwitterOutlined className='iconMessage' />Twitter</div>
                </Col>
            </Row>
        </div>
    );
};

export default PartageFormulaire;